import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStatus, SUCCESS, ERROR } from '@rootstrap/redux-tools';

import useToast from 'hooks/useToast';
import useAnalytics from 'hooks/useAnalytics';
import { MIXPANEL_EVENTS } from 'constants/constants';
import { replaceError } from 'utils/helpers';
import { reportCelebrity } from 'state/actions/celebritiesActions';

export default () => {
  const dispatch = useDispatch();
  const { trackEvent } = useAnalytics();
  const { status, error } = useStatus(reportCelebrity);

  const { showErrorToast, showToast } = useToast();

  useEffect(() => {
    if (status === SUCCESS) {
      trackEvent(MIXPANEL_EVENTS.reportCelebrity);
      showToast('The User was successfully reported!');
      dispatch(reportCelebrity.reset());
    }
    if (status === ERROR) {
      showErrorToast(replaceError(error, /^reason /));
      dispatch(reportCelebrity.reset());
    }
  }, [dispatch, showErrorToast, showToast, status, error]);

  return useCallback(
    ({ celebrityId, params }) => dispatch(reportCelebrity({ celebrityId, params })),
    [dispatch]
  );
};
